import React from 'react';
import PropTypes from 'prop-types';

import Page from '@Containers/Page';
import BreadcrumbsContainer from '@Containers/Breadcrumbs';
import ResultsFilters from '@Containers/ResultsFilters';
import ResultToolbarContainer from '@Containers/ResultToolbar';
import { mapContextToTitle } from '@Containers/ResultToolbar/ResultToolbarConstants';
import DatabaseSwitcherTabs from '@Containers/ResultToolbar/DatabaseSwitcher';
import HeatmapTable from '@Pages/Heatmap/HeatmapTable';

import './Heatmap.scss';

function Heatmap({
  fromContext,
  isDbSwitcherVisible,
  availableDatabases,
  currentDatabase,
  selectDatabase,
  showResultsList,
  toggleFullScreenMode,
  toggleLegend,
  toggleNavigator,
  isLimitDisabled,
  limitTo,
  isExportEnabled,
  openExportDialog,
  goToResultPage,
  heatmapData,
  heatmapSettings,
  onInitData,
  onRequestData,
  onSelectionChange,
}) {
  return (
    <Page withFooter={false} pageClassName="react-heatmap-page">
      <BreadcrumbsContainer />
      <ResultsFilters />
      <section id="results-container" className="results-container" aria-label="Bioactivity Visualization">
        {/* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex */}
        <div className="results-wrapper" id="main-content" tabIndex="0">
          <div className="results-wrapper-inner">
            <ResultToolbarContainer
              openHeatmapIndicator
              isDbSwitcherVisible={isDbSwitcherVisible}
              availableDatabases={availableDatabases}
              currentDatabase={currentDatabase}
              selectDatabase={selectDatabase}
              showResultsList={showResultsList}
              toContextLabel={mapContextToTitle[fromContext]}
              setFullScreenMode={toggleFullScreenMode}
              toggleLegend={toggleLegend}
              toggleNavigator={toggleNavigator}
              disableLimit={isLimitDisabled}
              limitTo={limitTo}
              isExportEnabled={isExportEnabled}
              openExportDialog={openExportDialog}
              goToResultPage={goToResultPage}>
              <DatabaseSwitcherTabs
                className="hide-for-heatmap-in-fullscreen"
                availableDatabases={availableDatabases}
                isDbSwitcherVisible={isDbSwitcherVisible}
                currentDatabase={currentDatabase}
                selectDatabase={selectDatabase}
              />
            </ResultToolbarContainer>
            <div className="react-heatmap-page__wrapper">
              {heatmapData && (
                <HeatmapTable
                  heatmapData={heatmapData}
                  settings={heatmapSettings}
                  onInitData={onInitData}
                  onRequestData={onRequestData}
                  onSelectionChange={onSelectionChange}
                />
              )}
            </div>
          </div>
        </div>
      </section>
    </Page>
  );
}

Heatmap.propTypes = {
  fromContext: PropTypes.string,
  isDbSwitcherVisible: PropTypes.bool,
  availableDatabases: PropTypes.array,
  currentDatabase: PropTypes.object,
  selectDatabase: PropTypes.func.isRequired,
  showResultsList: PropTypes.func.isRequired,
  toggleFullScreenMode: PropTypes.func.isRequired,
  toggleLegend: PropTypes.func.isRequired,
  toggleNavigator: PropTypes.func.isRequired,
  isLimitDisabled: PropTypes.bool,
  limitTo: PropTypes.func.isRequired,
  isExportEnabled: PropTypes.bool,
  openExportDialog: PropTypes.func.isRequired,
  goToResultPage: PropTypes.func.isRequired,
  heatmapData: PropTypes.object,
  heatmapSettings: PropTypes.object.isRequired,
  onInitData: PropTypes.func.isRequired,
  onRequestData: PropTypes.func.isRequired,
  onSelectionChange: PropTypes.func.isRequired,
};

export default Heatmap;
